import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-secondary text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12">
          <div className="lg:col-span-1">
            <div className="inline-block">
              <img 
                src="/logos/footer_logo.png" 
                alt="Asbestosurv" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-sm text-white/80 leading-relaxed mt-6">
              Professional asbestos surveys and management services across the UK. Fully compliant with CAR 2012.
            </p>
          </div>

          <div>
            <h3 className="font-headings text-lg font-bold mb-6 uppercase tracking-wide">Company</h3>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-home">
                Home
              </Link>
              <Link to="/about-asbestos" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-about-asbestos">
                About Asbestos
              </Link>
              <Link to="/faq" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-faq">
                FAQ
              </Link>
              <Link to="/knowledge-hub" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-knowledge-hub">
                Knowledge Hub
              </Link>
              <Link to="/case-studies" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-case-studies">
                Case Studies
              </Link>
              <Link to="/team" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-team">
                Our Team
              </Link>
              <Link to="/guides" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-guides">
                Compliance Guides
              </Link>
              <Link to="/contact" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-contact">
                Contact Us
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="font-headings text-lg font-bold mb-6 uppercase tracking-wide">Quality & Compliance</h3>
            <nav className="flex flex-col gap-3">
              <Link to="/quality-policy" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-quality-policy">
                Quality Policy
              </Link>
              <Link to="/qms-scope" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-qms-scope">
                QMS Scope & Certification
              </Link>
              <Link to="/compliance-commitment" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-compliance-commitment">
                Compliance & Improvement
              </Link>
              <Link to="/privacy-policy" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-privacy">
                Privacy Policy
              </Link>
              <Link to="/terms-conditions" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-terms">
                Terms & Conditions
              </Link>
              <Link to="/complaints" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-complaints">
                Complaints Procedure
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="font-headings text-lg font-bold mb-6 uppercase tracking-wide">Locations</h3>
            <nav className="flex flex-col gap-3">
              <Link to="/locations/essex" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-loc-essex">Essex</Link>
              <Link to="/locations/london" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-loc-london">London</Link>
              <Link to="/locations/kent" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-loc-kent">Kent</Link>
              <Link to="/locations/hertfordshire" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-loc-herts">Hertfordshire</Link>
              <Link to="/locations/suffolk" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-loc-suffolk">Suffolk</Link>
              <Link to="/locations/surrey" className="text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-loc-surrey">Surrey</Link>
            </nav>
          </div>

          <div>
            <h3 className="font-headings text-lg font-bold mb-6 uppercase tracking-wide">Contact Us</h3>
            <div className="flex flex-col gap-4">
              <a href="tel:07704885084" className="flex items-center gap-3 text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-phone">
                <Phone className="h-4 w-4 flex-shrink-0" />
                07704 885084
              </a>
              <a href="mailto:info@asbestosurv.co.uk" className="flex items-center gap-3 text-sm text-white/80 hover:text-primary transition-colors" data-testid="footer-email">
                <Mail className="h-4 w-4 flex-shrink-0" />
                info@asbestosurv.co.uk
              </a>
              <div className="flex items-start gap-3 text-sm text-white/80">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>
                  26 White Horse Lane<br />
                  Maldon<br />
                  CM9 5QP
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="text-sm text-white/60">
              &copy; {new Date().getFullYear()} Asbestosurv. All rights reserved.
            </div>
            <div className="flex items-center gap-6 text-sm text-white/60 md:justify-end">
              <span>CAR 2012 Compliant | HSG264 Compliant</span>
              <Link to="/crm/login" className="text-white/40 hover:text-white/60 transition-colors" data-testid="footer-staff-login">
                Staff Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
